import { render, staticRenderFns } from "./ArticleEditor.vue?vue&type=template&id=05780396&scoped=true&"
import script from "./ArticleEditor.vue?vue&type=script&lang=js&"
export * from "./ArticleEditor.vue?vue&type=script&lang=js&"
import style0 from "./ArticleEditor.vue?vue&type=style&index=0&id=05780396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05780396",
  null
  
)

export default component.exports